import Footer from "../components/common/Footer.jsx";
import { Link } from "react-router-dom";
import Header from "../components/common/Header.jsx";
import css from "../components/common/innerPageStyles.js";

// TODO: replace with the real App Store URL
const APP_STORE_URL = "#";

const jsonLd = `{
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://www.futurefamilyai.com/#org",
   "name": "FutureFamilyAI",
   "url": "https://www.futurefamilyai.com/",
   "logo": "https://www.futurefamilyai.com/wp-content/uploads/futurefamilyai-logo.png",
   "parentOrganization": {
    "@type": "Organization",
    "name": "HelixFoundry, Inc."
   },
   "sameAs": [
    "[SOCIAL_PROFILE_URLS]"
   ]
  },
  {
   "@type": "WebPage",
   "@id": "https://www.futurefamilyai.com/about/#webpage",
   "url": "https://www.futurefamilyai.com/about/",
   "name": "About Us & Clinical Oversight | FutureFamilyAI",
   "description": "Meet the physicians behind FutureFamilyAI: protocol by Dr. Kulsoom Baloch, content by Dr. Pooja Patel, MD, medical review by Dr. Rashmi Gulati, MD.",
   "inLanguage": "en-US",
   "datePublished": "2026-10-20",
   "dateModified": "2026-10-20",
   "author": {
    "@type": "Person",
    "name": "Dr. Kulsoom Baloch, MBBS, MPH",
    "jobTitle": "Clinical Protocol Author, FutureFamilyAI",
    "url": "https://www.futurefamilyai.com/about/#kulsoom-baloch",
    "worksFor": {
     "@type": "Organization",
     "name": "FutureFamilyAI"
    }
   },
   "reviewedBy": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "lastReviewed": "2026-10-20",
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   },
   "speakable": {
    "@type": "SpeakableSpecification",
    "cssSelector": [
     ".speakable-content"
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://www.futurefamilyai.com/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "About & Clinical Oversight",
     "item": "https://www.futurefamilyai.com/about/"
    }
   ]
  },
  {
   "@type": "FAQPage",
   "mainEntity": [
    {
     "@type": "Question",
     "name": "Who created FutureFamilyAI?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "FutureFamilyAI was developed by HelixFoundry, Inc., with a clinical protocol by Dr. Kulsoom Baloch, MBBS, MPH, and medical review by Dr. Rashmi Gulati, MD."
     }
    },
    {
     "@type": "Question",
     "name": "Is FutureFamilyAI connected to real doctors?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes. Clinical content and escalation rules are developed and reviewed by physicians, and care-team review is part of every Orange and Red status."
     }
    },
    {
     "@type": "Question",
     "name": "What is Patients Medical?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Patients Medical is a Manhattan medical practice founded in 1974. Its Medical Director, Dr. Rashmi Gulati, MD, reviews FutureFamilyAI's clinical content."
     }
    },
    {
     "@type": "Question",
     "name": "How is FutureFamilyAI related to Surrogacy4All?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Surrogacy4All uses FutureFamilyAI to support its gestational surrogates and intended parents."
     }
    },
    {
     "@type": "Question",
     "name": "Is FutureFamilyAI FDA-approved?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness and awareness tool. It is not a medical device and is not FDA-cleared."
     }
    },
    {
     "@type": "Question",
     "name": "Is FutureFamilyAI available outside the U.S.?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Not yet. The app is currently available in the United States only."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI replace my doctor or prenatal visits?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own clinician has more context between visits. Your care team makes every medical decision, and you should keep all scheduled appointments."
     }
    },
    {
     "@type": "Question",
     "name": "How much does FutureFamilyAI cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for wearable trends) a smartwatch are purchased separately."
     }
    }
   ]
  }
 ]
}`;

export default function AboutPage() {
  return (
    <div className="wrapper2">
      <style>{css}</style>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLd }}
      />
      <Header />
      <main className="ffh-home">
        <section className="ffh-page-hero">
          <div className="ffh-wrap">
            <nav className="ffh-crumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span>›</span>
              <span>About &amp; Clinical Oversight</span>
            </nav>
            <aside className="ffh-facts" aria-label="Fast facts">
              <div className="ffh-facts-title">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v6M12 7.5v.5" />
                </svg>{" "}
                Fast facts
              </div>
              <p className="ffh-q">
                FutureFamilyAI is a physician-connected pregnancy and
                family-planning wellness app developed by HelixFoundry, Inc.
              </p>
              <details>
                <summary>
                  More fast facts: audience, key stat, safety, cost
                </summary>
                <dl>
                  <div>
                    <dt>Who it&apos;s for</dt>
                    <dd>All audiences (trust page)</dd>
                  </div>
                  <div>
                    <dt>Key stat</dt>
                    <dd>
                      Hypertensive disorders were present in about 1 in 7 U.S.
                      delivery hospitalizations (2017–2019). (CDC, MMWR 2022)
                    </dd>
                  </div>
                  <div>
                    <dt>Safety &amp; oversight</dt>
                    <dd>
                      Wellness tool, not a medical device. Orange and Red
                      statuses reviewed by a real care team. Not for emergencies
                      — call 911.
                    </dd>
                  </div>
                  <div>
                    <dt>Why FutureFamilyAI</dt>
                    <dd>
                      Named, credentialed authors on every page · Clinical
                      heritage since 1974 · Used by Surrogacy4All for its
                      surrogates
                    </dd>
                  </div>
                  <div>
                    <dt>Cost</dt>
                    <dd>
                      Free pilot through Dec 31, 2026; then $39.99/mo or
                      $399/yr. Devices separate.
                    </dd>
                  </div>
                  <div>
                    <dt>Get started</dt>
                    <dd>
                      Download on the App Store, or request free pilot access at
                      futurefamilyai.com/contact/
                    </dd>
                  </div>
                </dl>
              </details>
            </aside>
            <p className="ffh-entity">
              FutureFamilyAI is a physician-connected pregnancy and
              family-planning wellness app that turns home blood pressure
              readings from a validated cuff, smartwatch wellness trends and
              symptom notes into a simple color status your care team can review
              between visits. Its monitoring protocol was developed by Dr.
              Kulsoom Baloch, MBBS, MPH, using ACOG, SMFM, ISSHP and AHA
              guidance, and every page is medically reviewed by Dr. Rashmi
              Gulati, MD, Medical Director of Patients Medical (Manhattan, since
              1974). FutureFamilyAI is a product of HelixFoundry, Inc., and is
              used by Surrogacy4All to support its gestational surrogates.
            </p>
            <span className="ffh-eyebrow">WHO&apos;S BEHIND IT</span>
            <h1>About FutureFamilyAI — Technology Shaped by Physicians</h1>
            <p className="ffh-answer speakable-content">
              FutureFamilyAI is a physician-connected pregnancy and
              family-planning wellness app developed by HelixFoundry, Inc. Its
              monitoring protocol was written by Dr. Kulsoom Baloch, MBBS, MPH,
              surrogacy and fertility content by Dr. Pooja Patel, MD, and every
              page is medically reviewed by Dr. Rashmi Gulati, MD, Medical
              Director of Patients Medical, a Manhattan practice since 1974.
              Meet the team behind your care.
            </p>
            <div className="ffh-byline">
              <span>
                Written by{" "}
                <b>
                  <Link to="/about#kulsoom-baloch">
                    Dr. Kulsoom Baloch, MBBS, MPH
                  </Link>
                </b>
              </span>
              <span>
                Medically reviewed by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>Published October 2026 · Last updated October 2026</span>
            </div>
            <div className="ffh-cta-row">
              <Link
                className="ffh-btn ffh-primary"
                to="/contact-us?type=member"
              >
                Request Free Pilot Access
              </Link>
              <a className="ffh-btn ffh-ghost" href={APP_STORE_URL}>
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path
                    d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                    fill="currentColor"
                    stroke="none"
                  />
                </svg>
                Download on the App Store
              </a>
            </div>
          </div>
        </section>
        <section className="ffh-band" style={{ paddingBlock: "40px 64px" }}>
          <div className="ffh-wrap ffh-layout">
            <div className="ffh-prose">
              <figure
                className="ffh-photo"
                role="img"
                aria-label="FutureFamilyAI clinical team: Dr. Rashmi Gulati, Dr. Kulsoom Baloch and Dr. Pooja Patel"
              >
                <figcaption>
                  <b>Photo slot</b> · Professional headshots (supplied by each
                  physician) in a consistent 3-up layout: Dr. Rashmi Gulati, Dr.
                  Kulsoom Baloch, Dr. Pooja Patel. Same background tone and
                  crop. Use only approved real photos.
                  <br />
                  <b>Alt:</b> FutureFamilyAI clinical team: Dr. Rashmi Gulati,
                  Dr. Kulsoom Baloch and Dr. Pooja Patel
                </figcaption>
              </figure>
              <section className="ffh-keystats" id="key-stats">
                <h2>Key statistics</h2>
                <ul>
                  <li>
                    Hypertensive disorders were present in about 1 in 7 U.S.
                    delivery hospitalizations (2017–2019).
                    <cite>
                      Source:{" "}
                      <a href="https://www.cdc.gov/mmwr/volumes/71/wr/mm7117a1.htm">
                        CDC, MMWR 2022
                      </a>
                    </cite>
                  </li>
                </ul>
              </section>
              <section id="s1">
                <h2>Our mission</h2>
                <p>
                  Pregnancy happens every day, not just on appointment days. We
                  built FutureFamilyAI so that families — and the clinicians who
                  care for them — can see the days in between, calmly and
                  clearly.
                </p>
              </section>
              <section id="s2">
                <h2>Clinical leadership</h2>
                <ul>
                  <li>
                    Dr. Rashmi Gulati, MD — Medical Director, Patients Medical;
                    medical reviewer for all content.
                  </li>
                  <li>
                    Dr. Kulsoom Baloch, MBBS, MPH — Clinical protocol author.
                  </li>
                  <li>
                    Dr. Pooja Patel, MD — Surrogacy and fertility content
                    author.
                  </li>
                </ul>
              </section>
              <div className="ffh-inline-cta">
                <p>Free pilot enrollment is open through December 31, 2026.</p>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/contact-us?type=member"
                >
                  Request Free Pilot Access
                </Link>
              </div>
              <section id="s3">
                <h2>How we keep it safe</h2>
                <ul>
                  <li>Validated cuff is the only blood pressure source.</li>
                  <li>Members see color status, never numeric risk scores.</li>
                  <li>Humans review every Orange and Red status.</li>
                  <li>
                    Not real-time and never a substitute for emergency care.
                  </li>
                </ul>
              </section>
              <section id="s4">
                <h2>Who we are</h2>
                <p>
                  FutureFamilyAI is a product of HelixFoundry, Inc. It is used
                  by Surrogacy4All to support gestational surrogates and
                  intended parents, and clinical support is provided through
                  Patients Medical, an independent professional practice.
                </p>
              </section>
              <section id="faq">
                <h2>Frequently asked questions</h2>
                <div className="ffh-faq">
                  <details open>
                    <summary>Who created FutureFamilyAI?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        FutureFamilyAI was developed by HelixFoundry, Inc., with
                        a clinical protocol by Dr. Kulsoom Baloch, MBBS, MPH,
                        and medical review by Dr. Rashmi Gulati, MD.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Is FutureFamilyAI connected to real doctors?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Yes. Clinical content and escalation rules are developed
                        and reviewed by physicians, and care-team review is part
                        of every Orange and Red status.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>What is Patients Medical?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Patients Medical is a Manhattan medical practice founded
                        in 1974. Its Medical Director, Dr. Rashmi Gulati, MD,
                        reviews FutureFamilyAI&apos;s clinical content.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      How is FutureFamilyAI related to Surrogacy4All?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        Surrogacy4All uses FutureFamilyAI to support its
                        gestational surrogates and intended parents.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Is FutureFamilyAI FDA-approved?</summary>
                    <div className="ffh-ans">
                      <p>
                        No. FutureFamilyAI is a wellness and awareness tool. It
                        is not a medical device and is not FDA-cleared.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Is FutureFamilyAI available outside the U.S.?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        Not yet. The app is currently available in the United
                        States only.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does FutureFamilyAI replace my doctor or prenatal visits?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. FutureFamilyAI is a wellness tool that organizes
                        your readings and symptoms so your own clinician has
                        more context between visits. Your care team makes every
                        medical decision, and you should keep all scheduled
                        appointments.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How much does FutureFamilyAI cost?</summary>
                    <div className="ffh-ans">
                      <p>
                        Eligible participants pay no subscription fee during the
                        free pilot through December 31, 2026. After that,
                        Complete Monitoring is $39.99/month or $399/year. A
                        compatible phone, validated cuff and (for wearable
                        trends) a smartwatch are purchased separately.
                      </p>
                    </div>
                  </details>
                </div>
                <div className="ffh-cta-row">
                  <Link
                    className="ffh-btn ffh-primary"
                    to="/contact-us?type=member"
                  >
                    Request Free Pilot Access
                  </Link>
                  <a className="ffh-btn ffh-ghost" href={APP_STORE_URL}>
                    <svg
                      viewBox="0 0 24 24"
                      width="18"
                      height="18"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path
                        d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                        fill="currentColor"
                        stroke="none"
                      />
                    </svg>
                    Download on the App Store
                  </a>
                </div>
              </section>
              <section className="ffh-authorbox">
                <span className="ffh-ph">KB</span>
                <div className="ffh-stack" style={{ gap: "6px" }}>
                  <h3>Dr. Kulsoom Baloch, MBBS, MPH</h3>
                  <p>
                    Clinical Protocol Author, FutureFamilyAI. Dr. Kulsoom
                    Baloch, MBBS, MPH, is the clinical protocol author for
                    FutureFamilyAI and a published researcher in reproductive
                    and maternal health. She developed the app&apos;s monitoring
                    protocol using ACOG, SMFM, ISSHP and AHA guidance.
                  </p>
                  <p>
                    Medically reviewed by{" "}
                    <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                    , Medical Director, Patients Medical. Last updated: October
                    2026.
                  </p>
                </div>
              </section>
              <section>
                <h2>Keep reading</h2>
                <div className="ffh-related">
                  <Link to="/how-it-works">How It Works →</Link>
                  <Link to="/pregnancy-monitoring">Pregnancy Monitoring →</Link>
                  <Link to="/pricing">Pricing →</Link>
                  <Link to="/privacy-safety">Privacy &amp; Safety →</Link>
                  <Link to="/faq">Frequently Asked Questions →</Link>
                  <a href="https://www.patientsmedical.com">
                    https://www.patientsmedical.com →
                  </a>
                </div>
              </section>
              <p className="ffh-notice">
                FutureFamilyAI is a wellness and awareness tool. It is not a
                medical device, is not FDA-cleared, does not diagnose or treat
                any condition, and is not monitored in real time. It supports —
                and does not replace — your prenatal care. In an emergency, call
                911.
              </p>
            </div>
            <aside className="ffh-aside">
              <div className="ffh-toc">
                <b>What you will learn</b>
                <ol>
                  <li>
                    <a href="#s1">Our mission</a>
                  </li>
                  <li>
                    <a href="#s2">Clinical leadership</a>
                  </li>
                  <li>
                    <a href="#s3">How we keep it safe</a>
                  </li>
                  <li>
                    <a href="#s4">Who we are</a>
                  </li>
                  <li>
                    <a href="#faq">Frequently asked questions</a>
                  </li>
                </ol>
              </div>
              <div className="ffh-cta-card">
                <b>Join the free pilot</b>
                <span>No subscription fee through Dec 31, 2026.</span>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/contact-us?type=member"
                >
                  Request Free Pilot Access
                </Link>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
